import React, { Component } from "react";
import LoginForm from "./../Login/LoginForm";
import ForgotPassword from "./../Forget/ForgotPassword";
import ResetPassword from "./../Reset/ResetPassword";
import { Switch, Route } from "react-router-dom";
import ResetPasswordV1 from "./../Forget/ResetPassword";

import Url from "app/shared/constants/Url";
import { withTranslation } from "react-i18next";
const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <div className="inner-text">
        <h1>404</h1>
        <h2>Page Not Found</h2>
      </div>
    </div>
  );
};

export default withTranslation(["util"])(
  class AuthRight extends Component {
    constructor(props) {
      super(props);
      this.state = {
        logoUrl: "",
        companyName: "",
        companyTagLine: "",
        tagLine: {},
      };
    }

    componentDidMount = () => {
      this._getLogo();
      // this._getTagline();
    };

    _getLogo = async () => {
      const requestData = {
        status: 1,
        link: Url.clientURL,
      };

      import("app/shared/utility/UtilFunction").then((utilFunction) => {
        let responseObj = utilFunction.sharedAxiosAPI(
          Url.compnayLogo,
          undefined,
          requestData,
        );

        responseObj
          .then(async (response) => {
            if (response.data.status === 200) {
              await this.setState({
                logoUrl: response.data.data.logo,
                companyName: response.data.data.company_name,
                companyTagLine: response.data.data.tag_line,
              });
            }
          })
          .catch((error) => console.log(error));
      });
    };

    _getTagline = async () => {
      let { hostname, protocol } = window.location;
      const requestData = {
        status: 1,
        link: `${protocol}//${hostname}`,
      };

      import("app/shared/utility/UtilFunction").then((utilFunction) => {
        let responseObj = utilFunction.sharedAxiosAPI(
          Url.tagLine,
          undefined,
          requestData,
        );

        responseObj
          .then(async (response) => {
            if (response.data.status === 200) {
              await this.setState({ tagLine: response.data.data });
            }
          })
          .catch((error) => console.log(error));
      });
    };

    render() {
      const { t } = this.props;
      const themeColor = this.props.themeColor;

      return (
        <>
          <div className="sign-column s1">
            <div className="sign-column-face s2">
              <div className="s3">
                <Switch>
                  <Route path="/auth/login">
                    <LoginForm themeColor={themeColor} />
                  </Route>
                  <Route path="/auth/forget-password">
                    <ForgotPassword themeColor={themeColor} />
                  </Route>
                  <Route path="/auth/set-password/:token/:flag">
                    <ResetPassword themeColor={themeColor} />
                  </Route>
                  <Route path="/auth/reset-password">
                    <ResetPasswordV1 themeColor={themeColor} />
                  </Route>
                  <Route path="/sid">
                    <h1>{t("auth")}</h1>
                  </Route>
                  <Route path="/sid">
                    <h1>{t("auth")}</h1>
                  </Route>

                  <Route path="*" exact={true} component={PageNotFound} />
                </Switch>
              </div>
            </div>
          </div>
        </>
      );
    }
  },
);
